import { render } from "./BadgeProgess.vue?vue&type=template&id=183b76d3&scoped=true"
import script from "./BadgeProgess.vue?vue&type=script&lang=js"
export * from "./BadgeProgess.vue?vue&type=script&lang=js"

import "./BadgeProgess.vue?vue&type=style&index=0&id=183b76d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183b76d3"]])

export default __exports__